import { useEffect, useRef, useState } from "react";
import config from "../../config";

const ClientOnboardingHost = () => {
    const [token, setToken] = useState('');
    const tokenInputRef = useRef(null);

    useEffect(() => {
        const handleESignAgreement = (event) => {
            // event.detail.status will be "success", "failure", or "failed"
            console.log("e-sign-agreement event received:", event.detail.status);

            // You can handle the result here, e.g.:
            if (event.detail.status === "success") {
                const statusDiv = document.getElementById("agreementSigningStatus");
                if (statusDiv) statusDiv.textContent = "eSign completed";
            } else if (event.detail.status === "failed" || event.detail.status === "Failure") {
                const statusDiv = document.getElementById("agreementSigningStatus");
                if (statusDiv) statusDiv.textContent = "eSign failed";
            } else {
                const statusDiv = document.getElementById("agreementSigningStatus");
                if (statusDiv) statusDiv.textContent = "eSign status unknown";
            }

        };

        document.addEventListener("e-sign-agreement", handleESignAgreement);

        return () => {
            document.removeEventListener("e-sign-agreement", handleESignAgreement);
        };
    }, []);

    useEffect(() => {
        const scriptUrls = [
            "https://code.jquery.com/jquery-3.6.0.min.js", // Add this line first!
            "/agreementsigning/jquery_blockUI.js",
            "/agreementsigning/min.js",
            "/agreementsigning/digio.js",
            "/agreementsigning/mosl_agreement-signing.js",
        ];

        const scripts = scriptUrls.map(url => {
            const script = document.createElement("script");
            script.src = url;
            //script.async = true;
            document.body.appendChild(script);
            return script;
        });

        // Call triggerAgreement when all scripts are loaded
        Promise.all(
            scripts.map(
                script =>
                    new Promise(resolve => {
                        script.onload = resolve;
                        script.onerror = resolve; // resolve even if error, to avoid hanging
                    })
            )
        ).then(() => {
            /* if (window.triggerAgreement) {
                // Provide actual arguments as needed
                window.triggerAgreement("http://localhost:8800/api/mosl/initiateSigning", "",
                    'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJLT0xLMTExMTEiLCJpYXQiOjE3NTExNzg0NTIsImV4cCI6MTc1MTI2NDg1Mn0._B4xVLPdIEGnA9IkJ0wkuy_2vtqzBXdYP49ks5IFJX2kqwwu6ZoslB3adKY2s5COOiFMq3R0Wap0pUCM2cgAEw',
                    "TV",
                    "esign");
            } */
        });

        return () => {
            scripts.forEach(script => {
                document.body.removeChild(script);
            });
        };
    }, []);

    const handleTokenChange = (e) => {
        setToken(e.target.value);
    };

    const handleStart = () => {
        if (window.triggerAgreement && token) {
            window.triggerAgreement(
                config.BL_API_URL + "/api/mosl/initiateSigning",
                "",
                token,
                "TV",
                "esign"
            );
        } else {
            alert("Please enter a token and ensure scripts are loaded.");
        }
    };

    return (
        <div className="w-full my-0 ">
            <br /><br /><br />
            <div id="agreementSigningStatus">Open</div>
            <br />
            <div>
                <input
                    type="text"
                    ref={tokenInputRef}
                    value={token}
                    onChange={handleTokenChange}
                    placeholder="Enter token"
                    style={{ width: "400px" }}
                />
                <button onClick={handleStart} style={{ marginLeft: "10px" }}>
                    Start eSign
                </button>
            </div>
        </div>
    )
}
export default ClientOnboardingHost